import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root{
    --swiper-navigation-color: var(--color-accent-secondary-default);
  }

  * {
    font-family: inherit;
    scroll-behavior: smooth;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }

  body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  #root {
    overflow: hidden;
    height: 100%;
  }

  a {
    color: initial;
  }

  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .react-select__menu-portal { /* TODO: Remove it after fixed it on toolkit */
    z-index: 9999!important;
  }

  .element-vibration {
    animation: vibration 0.5s;
  }

  .swiper-backface-hidden .swiper-slide {
    transform: none;
  }

  @keyframes vibration {
    0% { transform: translateX(0); }
    25% { transform: translateX(-5px); }
    50% { transform: translateX(5px); }
    75% { transform: translateX(-5px); }
    100% { transform: translateX(0); }
  }

  .text-editor-preview {
    word-break: break-word;

    strong,
    strong * {
      font-weight: 700;
    }

    ol,
    ul {
      padding-left: 16px;
    }
    ol li {
      list-style-type: decimal;
    }

    ul li {
      list-style-type: disc;
    }

    ol br,
    ul br {
      display: none;
    }
  }
`;
